import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { UserIntent, UserRole } from 'containers/Demarrage/types';
import { Role } from 'types/user';
import { orderByNiveau } from 'utils/orderByNiveau';
import { USER_KEY } from 'queries/user/useUser';
import { useTranslation } from 'react-i18next';

interface SeachQuery {
  query: string;
}

interface Payload {
  userRoles?: UserRole[];
  roles?: Role[];
  otherRoleDetails?: string;
  edtTemplateId?: string;
  sequenceTemplateId?: string;
  programTemplateId?: string;
  edtTemplateDocumentId?: string;
  sequenceTemplateDocumentId?: string;
  programTemplateDocumentId?: string;
  sharedProgrammationId?: string;
  etablissementUai?: string;
  etablissementNcesSchoolId?: string;
  schoolName?: string;
  zoneId?: string;
  userIntents?: UserIntent[];
  userCountryCode?: string;
  searchQueries?: SeachQuery[];
  degreesWithWorkingDays?: Array<{
    degree: string;
    workingDays: number[];
  }>;
}

export function useFinalizeDemarrage() {
  const { notifyError } = useNotification();
  const queryClient = useQueryClient();
  const requestURL = '/user/onboarding/finalize';
  const { t } = useTranslation(['onboarding']);

  const { mutateAsync } = useMutation({
    mutationFn: (payload: Payload) =>
      request(`${requestURL}`, {
        method: 'POST',
        body: {
          ...payload,
          degreesWithWorkingDays: orderByNiveau<{
            degree: string;
            workingDays: number[];
          }>(payload?.degreesWithWorkingDays || [], v => v.degree),
        },
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [USER_KEY],
      });
    },
    onError: () => {
      notifyError({
        title: t('onboarding:messages.finalizeError'),
      });
    },
  });
  return mutateAsync;
}
